import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { PurchaseItemsFormValues } from '@/core/domain/purchase/purchaseItem/PurchaseItem.types';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { Col, Form, FormInstance, Row } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<PurchaseItemsFormValues>;
}

const IiForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  const { purchase } = useReleasePurchaseFormContext();

  return (
    <Form form={form}>
      <Row gutter={[12, 12]}>
        <Col lg={6} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueBaseOfImportTax']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.iI.taxRegime.valueBaseOfImportTax',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={6} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueOfCustomsExpenses']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.iI.taxRegime.valueOfCustomsExpenses',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={6} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'valueImportTax']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.iI.taxRegime.valueImportTax',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>

        <Col lg={6} span={24} md={12}>
          <FloatingFormItem
            name={['purchaseItemTaxes', 'amountOfTaxOnFinancialTransactions']}
            label={intl.formatMessage({
              id: 'purchases.details.itemsPurchase.iI.taxRegime.amountOfTaxOnFinancialTransactions',
            })}
          >
            <InputDecimal disabled={purchase?.boschMigration} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default IiForm;
